export default __webpack_public_path__ + "static/media/HCM-software.abad35f8.png";